import { ExercisePreviewDialog } from "src/workouts/ExercisePreviewDialog";
import { ExercisePreviewImage } from "src/workouts/ExercisePreviewImage";
import { type ExerciseData } from "src/workouts/WorkoutEditStore";

interface TabContentProps {
  exercise: ExerciseData;
}

export function TabContent(props: TabContentProps) {
  return (
    <>
      <div
        onPointerDown={(e) => {
          e.stopPropagation();
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <ExercisePreviewDialog exercise={props.exercise}>
          <ExercisePreviewImage
            exercise={props.exercise}
            imageClassName="h-6 w-6 hover:outline hover:outline-active-primary hover:cursor-pointer"
          />
        </ExercisePreviewDialog>
      </div>
      <span className="first-letter:capitalize">{props.exercise.name}</span>
    </>
  );
}
